<template>
    <div class="heading-analytics-perfection">
        <h2 class="heading-analytics-perfection__heading">{{ textHeading }}</h2>
        <p class="heading-analytics-perfection__desc">{{ textDesc }}</p>
    </div>
</template>
<script>
    export default {
        props: {
            textHeading: {
                type: String,
                default: 'Lorem Ipsum'
            },
            textDesc: {
                type: String,
                default: 'Lorem ipsum dolor sit amet.'
            }
        }
    };
</script>
<style scoped src="@/css/components/heading-analytics-perfection.css"></style>